export type VisitorLocation = {
  countryCode: string | null; // ISO 3166-1 alpha-2
  callingCode: string | null; // e.g. +971
};

let cached: Promise<VisitorLocation> | null = null;

// One network lookup per visit, shared by every field that pre-fills from location
export function lookupVisitorLocation(): Promise<VisitorLocation> {
  if (!cached) {
    cached = (async () => {
      try {
        const controller = new AbortController();
        const timer = window.setTimeout(() => controller.abort(), 3500);
        const res = await fetch('https://ipapi.co/json/', { signal: controller.signal });
        window.clearTimeout(timer);
        if (!res.ok) return { countryCode: null, callingCode: null };
        const data: { country_code?: string; country_calling_code?: string } = await res.json();
        return {
          countryCode: data.country_code && /^[A-Z]{2}$/.test(data.country_code) ? data.country_code : null,
          callingCode:
            data.country_calling_code && /^\+\d{1,4}$/.test(data.country_calling_code) ? data.country_calling_code : null,
        };
      } catch {
        return { countryCode: null, callingCode: null };
      }
    })();
  }
  return cached;
}

export function visitorTimeZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return '';
  }
}
